angular.module('filters').filter('membershipTaxStatus', function() {
  return function(status) {
    switch (status) {
      case 'inc_tax':
        return 'Tax inclusive';
      case 'ex_tax':
        return 'Tax exclusive';
      case 'tax_exempt':
        return 'Tax exempt';
      default:
        return 'Not Set';
    }
  };
});
